module.exports = __webpack_public_path__ + "static/media/blocked.c0b26e57.svg";